/*
   Theme Selector
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import '../../css/JourneySelector.css'
import { resetToJourney, setSelectedJourneyForModal } from '../../actions/journey-actions'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';
import Modal from '../Modal'
import {
  journeys,
  journeysFiltered,
  selectedJourneyForModal,
  kioskMode
} from '../../selectors/journeyState-selectors'

import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import selectButton from '../../assets/btn_select.png'

class JourneySelector extends React.Component {
   constructor(props) {
      super(props)
      this.state = { selectedJourney: null }
   }

   handleClick(journeyId) {
      const { galleryId, resetToJourney } = this.props
      resetToJourney(galleryId, journeyId)
   }
   
   render() {
      const { journeysFiltered, galleryId, selectedJourneyForModal, kioskMode, setSelectedJourneyForModal } = this.props

      /*let button
      if (isFetching) {
         button = <button className={'start-journey not-yet'}>Loading...</button>
      } else {
         if (this.state.selectedJourney)
         {
            button = <button  className={'start-journey'} onClick={() => this.handleClick()}>Start Journey</button>
         } else {
            button = <button  className={'start-journey not-yet'}>Please Select A Journey</button>
         }
      } */
      return   (
           <div className={'journey-selector-container'}>
           <div className={'bordered-container title'}>
            <div className={'border'}>
               <span className={'large-2'}>Select a Theme</span>
            </div>
            </div>
           {journeysFiltered.valueSeq().map(journey => (
              <div className={'select-journey'} key={`select-journey-${journey.id}`}>
                {/* ----- layout is screwy if images havent loaded yet */}
                <Hammer onTap={() => setSelectedJourneyForModal(galleryId, journey.id)} options={tapOptions} >
                  { (kioskMode && true && journey.getIn(['animated_cover', 'url'])) ?
                      <video width="100%" height="100%" loop autoPlay>
                        <source src={`${journey.getIn(['animated_cover', 'url'])}`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    :
                      <img 
                        src={`${journey.getIn(['journey_image', 'url'])}`} 
                        alt={`journey-${journey.id}`} 
                        draggable={false}
                      /> 
                  }
                </Hammer>
                <div className="caption large-1">
                  {journey.title}
                </div>
              </div>
            )
           )}

            <ReactCSSTransitionGroup
               transitionName="ui-transition-modal"
               transitionEnterTimeout={300}
               transitionLeaveTimeout={300}>
               {selectedJourneyForModal && 
                  <Modal onRequestClose={() => setSelectedJourneyForModal(galleryId, null)} 
                     key={`journeySelect-${galleryId}-modal`} 
                     className={'journey-select-modal'}>
                     <div className='large-1'>
                        <h1 className='large-4'>{selectedJourneyForModal.title}</h1>
                        <p className='large-3'>{selectedJourneyForModal.description}</p>
                        <Hammer onTap={() => this.handleClick(selectedJourneyForModal.id)} options={tapOptions} >
                           <img src={selectButton} alt={'continue button'} />
                        </Hammer>
                     </div>
                  </Modal>
               }
            </ReactCSSTransitionGroup>
         </div>
      )
   }
}

const mapStateToProps = (state, ownProps) => {
   return {
     journeys: journeys(state, ownProps),
     journeysFiltered: journeysFiltered(state, ownProps),
     selectedJourneyForModal: selectedJourneyForModal(state, ownProps),
     isFetching: state.journey.getIn(['isFetching', 'journeys']),
     kioskMode: kioskMode(state, ownProps),
     //showSelectJourney: showSelectJourney(state, ownProps),
     ...ownProps
   }
}
const mapDispatchToProps = dispatch => bindActionCreators({
   setSelectedJourneyForModal,
  resetToJourney,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneySelector)


// WEBPACK FOOTER //
// ./src/components/JourneyHome/JourneySelector.js